export default __webpack_public_path__ + "static/media/Group 3191@2x.9515ee37.png";